import React, { useState } from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import '../components/css/research.css';
import mask from '../components/images/ANIMAL CARE AND WELFARE.jpg';
import { Carousel } from 'react-bootstrap';
import '../components/css/CarouselComponent.css';

import img1 from '../components/images/Research & Innovation.jpg';
import img2 from '../components/images/Slider 2webp.webp';
import img3 from '../components/images/Slider 3webp.webp';
import img4 from '../components/images/Slider 4webp.webp';
import img5 from '../components/images/Slider 5webp.webp';
import img6 from '../components/images/Slider 6webp.webp';

import icon1 from '../components/images/R & I 1.png';
import icon2 from '../components/images/R & I 2.png';
import icon3 from '../components/images/R & I 3.png';
import continuumimg from '../components/images/Contunuum of Care infographics.png'

import { useInView } from "react-intersection-observer";





const Research = () => {
  const cardData = [
    {
      title: 'Integrated Innovation',
      description:
        'Create integrated solutions and ideas, developing new ways of producing and caring for animals, with less impact, simplicity and more efficiency.',
      icon: icon1,
    },
    {
      title: 'Engage and Collaborate',
      description:
        'Thinking and acting more widely in the animal health space, involving, connecting and working in collaboration with our clients, partners, and community in a movement of transformation and evolution of the sector.',
      icon: icon2,
    },
    {
      title: 'Building and Nourishing Relationships',
      description:
        'Establish open and transparent ways to inspire, invest, connect, collaborate, and do business/grow together.',
      icon: icon3,
    },
  ];




  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });




  const slides = [
    {
      id: 1,
      image: img1,

    },
    // {
    //   id: 2,
    //   image: img2,

    // },

    // {
    //   id: 3,
    //   image: img3,

    // },

    // {
    //   id: 4,
    //   image: img4,

    // },
    // {
    //   id: 5,
    //   image: img5,

    // },
    // {
    //   id: 6,
    //   image: img6,

    // },
  ];
  return (
    <>
      <Carousel interval={3000} fade={true} pause="hover" indicators={true}>
        {slides.map((slide) => (
          <Carousel.Item key={slide.id} className="carousel-item">
            {/* Background Image */}

            <div className="carousel-images-home">
              <img src={slide.image} alt={`Slide ${slide.id}`} className="img-fluid w-100" loading='lazy' />
            </div>


          </Carousel.Item>
        ))}
      </Carousel>

      <section className="hover-cards-section py-5">
        <Container>
          <Row className="g-4">
            {cardData.map((card, index) => (
              <Col key={index} md={4}>
                <Card className="hover-card text-center h-100">
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div>
                      <div className="icon mb-3">
                        <img src={`${card.icon}`} alt='' className={` text-primary`} style={{ width: '100px', height: '100px', objectFit: 'contain' }} loading='lazy'></img>
                      </div>
                      <Card.Title className="mb-3">{card.title}</Card.Title>
                      <Card.Text>{card.description}</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      <section>
        <Container className="py-5" ref={ref}>
          <Row className="align-items-center">
            {/* Left Side - Background Image and Four Icons */}
            <Col md={6} className="text-center modran-image-colomn position-relative">
              <img src={continuumimg} className="img-fluid w-100" alt="Background" loading='lazy' />

              {/* <Row className="four-cards-text-research d-flex align-items-center justify-content-center">
                {[{ img: i4, label: "PREDICT" },
                { img: i3, label: "DETECT" },
                { img: i1, label: "TREAT" },
                { img: i2, label: "PREVENT" }].map((item, i) => (
                  <Col xs={6} className="mb-3" key={i}>
                    <motion.div
                      className="care-box text-center"
                      initial="hidden"
                      animate={inView ? "visible" : "hidden"}
                      custom={i}
                      variants={iconVariants}
                    >
                      <img src={item.img} alt={item.label} className="mb-2" />
                      <h5 className="fw-bold">{item.label}</h5>
                    </motion.div>
                  </Col>
                ))}
              </Row> */}
            </Col>

            {/* Right Side - Text Content */}
            <Col md={6} className="continum-colmn">
              <h2 className="text-primaryrr">Continuum of Care</h2>
              <p>
                At Panav Biotech, we embrace a Continuum of Care model that supports animals at every stage of life—from preventive healthcare to early diagnostics, advanced treatments, and long-term wellness solutions. By integrating innovation with veterinary expertise, we deliver products and services that ensure pets, livestock, and companion animals receive consistent, high-quality care throughout their lifetime. This approach strengthens the bond between veterinarians, farmers, and pet parents while promoting sustainable animal health.
              </p>
              {/* <Button variant="primary">Read More</Button> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section className='animal-section-research'>
        <Container>
          <Row>
            <Col md={6}>
              <h2>ANIMAL CARE AND WELFARE</h2>
              <p>
                Animal health is not just about treatment—it’s about compassion, dignity, and responsible care. At Panav Biotech, we are committed to advancing animal welfare practices that improve both productivity and quality of life. Through innovative veterinary medicines, nutritional support, and responsible livestock management solutions, we help vets, farmers, and pet parents create environments where animals can thrive. Our focus on ethical, science-backed animal care reflects our mission to build a healthier future for both animals and the communities that depend on them.
              </p>
              {/* <Button>Learn More</Button> */}
            </Col>
            <Col md={6}>
              <img src={mask} className='img-fluid w-100' alt='' loading='lazy' />
            </Col>
          </Row>
        </Container>
      </section>

    </>
  )
}

export default Research
